export const APP_VERSION = '2.7.0';
